import { defineStore } from 'pinia';
import axios from 'axios';

// Website Banners admin store. Mirrors useBlogStore/usePaymentRequestStore
// conventions. Banners are returned already ordered by the backend.
export const useBannerStore = defineStore('banners', {
    state: () => ({
        banners: [],
        loading: false,
        saving: false,
    }),

    actions: {
        async fetchBanners() {
            this.loading = true;
            try {
                const { data } = await axios.get('/admin/banners');
                this.banners = data.data ?? [];
            } finally {
                this.loading = false;
            }
        },

        async fetchBanner(id) {
            const { data } = await axios.get(`/admin/banners/${id}`);
            return data.data;
        },

        // payload is a FormData (multipart, so the image file uploads).
        async createBanner(payload) {
            this.saving = true;
            try {
                const { data } = await axios.post('/admin/banners', payload);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async updateBanner(id, payload) {
            this.saving = true;
            try {
                // POST fallback route accepts multipart updates (Laravel can't parse
                // multipart on PUT); backend maps both to BannerController@update.
                const { data } = await axios.post(`/admin/banners/${id}`, payload);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async deleteBanner(id) {
            await axios.delete(`/admin/banners/${id}`);
            this.banners = this.banners.filter(b => b.id !== id);
        },

        async toggleActive(id) {
            const { data } = await axios.patch(`/admin/banners/${id}/toggle-active`);
            const idx = this.banners.findIndex(b => b.id === id);
            if (idx !== -1) this.banners[idx] = data.data;
            return data.data;
        },

        async reorder(orderedIds) {
            await axios.post('/admin/banners/reorder', { order: orderedIds });
        },
    },
});
